import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'
import connectPropTypes from './utilities/connectPropTypes'
import styles from './QuickLogin.icss'

class QuickLogin extends React.Component {
	constructor(props) {
		super(props)

		this.doAuthFacebookRedirectLogin = this.doAuthFacebookRedirectLogin.bind(this)
		this.doAuthInstagramRedirectLogin = this.doAuthInstagramRedirectLogin.bind(this)
	}

	componentDidMount() {
		switch (this.props.provider) {
		case 'instagram':
			this.doAuthInstagramRedirectLogin()
			break
		case 'facebook':
			this.doAuthFacebookRedirectLogin()
			break
		default:
			// this should not happen...
			this.props.appRedirect('/')
			return
		}

		this.props.appShowTopBar(false)
		this.props.appShowBottomBar(false)
	}

	doAuthFacebookRedirectLogin() {
		this.props.authFacebookRedirectLogin()
	}

	doAuthInstagramRedirectLogin() {
		this.props.authInstagramRedirectLogin()
	}

	render() {
		return (
			<div className={styles.quickLoginWrapper}>
				<section className={styles.spinnerWrapper}>
					<div>
						<CircularProgress className={styles.spinner} size={24} thickness={4} />
					</div>
				</section>
			</div>
		)
	}
}

QuickLogin.contextTypes = {
	translate: PropTypes.func
}

QuickLogin.propTypes = {
	appRedirect: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowTopBar: PropTypes.func.isRequired,
	authFacebookRedirectLogin: PropTypes.func.isRequired,
	authInstagramRedirectLogin: PropTypes.func.isRequired,
	provider: PropTypes.string
}

QuickLogin.defaultProps = {
	provider: undefined
}

export const testing = {
	QuickLogin
}

export default connectPropTypes(QuickLogin)



// WEBPACK FOOTER //
// ./src/QuickLogin.jsx